window.Products.Clothing.RacerbackTankTop = function() {
};
window.Products.Clothing.RacerbackTankTop.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.RacerbackTankTop.dpi = 150;
window.Products.Clothing.RacerbackTankTop.has_3d = true;
window.Products.Clothing.RacerbackTankTop.id = 85;
window.Products.Clothing.RacerbackTankTop.slug = 'racerback-tank-top';
window.Products.Clothing.RacerbackTankTop.syncColors = true;
window.Products.Clothing.RacerbackTankTop.texturesLoaded = 0;
window.Products.Clothing.RacerbackTankTop.texturesLoading = false;
window.Products.Clothing.RacerbackTankTop.use_glb = true;

window.Products.Clothing.RacerbackTankTop.prototype.outsideObject = 1;
window.Products.Clothing.RacerbackTankTop.prototype.insideObject = 0;

window.Products.Clothing.RacerbackTankTop.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.color = three_color;
	}

	me.updateThreeTexture(modelViewer);
	var three_intensity = 1.5;

	if(color == "athletic_heather"){
		three_intensity = 2.5;
	}

	object.children[me.outsideObject].material.aoMapIntensity = three_intensity;

	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.aoMapIntensity = three_intensity;
	}
};

window.Products.Clothing.RacerbackTankTop.prototype.getColor = function(_name){
	colors = {
		"black": 0x111111,
		"white": 0xf9f9fb,
		"tahiti_blue": 0x0de7e8,
		"purple_rush": 0x8063d6,
		"hot_pink": 0xe85f97,
		"heather_gray": 0xbabcbf,
	};

	return new THREE.Color(colors[_name]);
};